import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const CertificationsAndPartnerPrograms_MultiListCard = () => {

    const cardDetaisl = [
        {
            title: "Security & Architecture",
            list: [
                {
                    list1: "Where is data stored?",
                    content: "In your selected cloud region(s); residency set per engagement."
                },
                {
                    list1: "Do you train on our data?",
                    content: "No, not by default. Any training/fine-tuning requires explicit contract and isolation."
                },
                {
                    list1: "How is access controlled?",
                    content: "SSO/OIDC, MFA, RBAC/least-privilege; all access is logged and reviewed."
                },
                {
                    list1: "Private connectivity?",
                    content: "Yes—VPC/VNet isolation with optional Private Link/Peering where supported."
                },
                {
                    list1: "Audit logs available?",
                    content: "Yes—immutable logs for admin actions, agent tool calls, approvals, and data access (exportable)."
                },
                {
                    list1: "Pen tests & scans?",
                    content: "Annual 3rd-party pentest (summary on request) + continuous SAST/DAST & container scans."
                },
                {
                    list1: "Retention & deletion?",
                    content: "Configurable retention; verified deletion and purge evidence provided on request."
                }
            ]
        },
        {
            title: "Commercial, Legal & Delivery",
            list: [
                {
                    list1: "DPA / SCCs / DPIA?",
                    content: "Yes—standard Data Processing Addendum, SCCs (where applicable), and DPIA support."
                },
                {
                    list1: "Contracting model?",
                    content: "MSA + SOW; optional Build-Operate-Transfer; pilot fixed-fee with defined success criteria."
                },
                {
                    list1: "IP ownership?",
                    content: "Your data & bespoke configs are yours; our core frameworks remain our IP (license granted)."
                },
                {
                    list1: "Pricing?",
                    content: "Transparent pilot pricing; production based on scope; optional success-fee for FinOps/deflection."
                },
                {
                    list1: "Onboarding time?",
                    content: "Typical pilot setup 1–2 weeks post green-light; security review can run in parallel."
                },
                {
                    list1: "Sub-processors?",
                    content: "Maintained list available; changes notified in advance per DPA."
                },
                {
                    list1: "Exit & portability?",
                    content: "Structured data export, documentation, and off-boarding support included."
                }
            ]
        }
    ]

    return (
        <>
            <Row>
                {
                    cardDetaisl.map((item, index) => {
                        return (
                            <Col className='card_margin' lg="6" key={index}>  
                                <Card className='multi_list_card'>
                                    <Card.Title className='multi_list_card_content_title'>{item.title}</Card.Title>
                                    <div className='multi_list_card_content'>
                                        <ul>
                                            {
                                                item.list.map((newitem, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {newitem.list1}
                                                            <p className='list_subitem'>{newitem.content}</p>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default CertificationsAndPartnerPrograms_MultiListCard